import { render, staticRenderFns } from "./ListWithMore.vue?vue&type=template&id=6f573652&scoped=true"
import script from "./ListWithMore.vue?vue&type=script&lang=ts"
export * from "./ListWithMore.vue?vue&type=script&lang=ts"
import style0 from "./ListWithMore.vue?vue&type=style&index=0&id=6f573652&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f573652",
  null
  
)

export default component.exports